// extracted by mini-css-extract-plugin
export default {"waterListWrap":"WaterList_waterListWrap__LHhcj","waterList":"WaterList_waterList__sBZR+","paragraph":"WaterList_paragraph__EigO6"};